// extracted by mini-css-extract-plugin
export default {"products":"Pt-z","card":"Qt-z","oosMessaging":"Rt-z"};